import { render, staticRenderFns } from "./ProspectThirdPageUrl.vue?vue&type=template&id=08a8ec4a&scoped=true"
import script from "./ProspectThirdPageUrl.vue?vue&type=script&lang=js"
export * from "./ProspectThirdPageUrl.vue?vue&type=script&lang=js"
import style0 from "./ProspectThirdPageUrl.vue?vue&type=style&index=0&id=08a8ec4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a8ec4a",
  null
  
)

export default component.exports